import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { ConfigProvider } from 'antd';
import { AuthProvider } from './auth/AuthContext';

// function Home() {
//   return <div className="p-4 text-xl">Welcome to RETISIO Invoice Generator</div>;
// }

// function CreateCustomers() {
//   const [form, setForm] = useState({ code: "", address: "", city: "", state: "", zip: "", country: "US" });

//   const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

//   const handleSubmit = async () => {
//     try {
//       const res = await fetch("http://localhost:3001/api/add-customer", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form)
//       });
//       const data = await res.json();
//       alert(data.message);
//     } catch (error) {
//       console.error("Error adding customer:", error);
//       alert("Failed to add customer.");
//     }
//   };

//   return (
//     <div className="p-4">
//       <h2 className="text-xl font-bold mb-4">Create Customer Manually</h2>
//       <div className="grid gap-2 max-w-md">
//         {Object.keys(form).map((key) => (
//           <input
//             key={key}
//             name={key}
//             value={form[key]}
//             onChange={handleChange}
//             className="border p-2 rounded"
//             placeholder={key.charAt(0).toUpperCase() + key.slice(1)}
//           />
//         ))}
//         <Button onClick={handleSubmit}>Save Customer</Button>
//       </div>
//     </div>
//   );
// }
// function ImportCustomers() {
//   const [file, setFile] = useState(null);

//   const handleUpload = () => {
//     if (!file) return alert("Please upload a CSV file");

//     Papa.parse(file, {
//       header: true,
//       complete: async (results) => {
//         try {
//           const res = await fetch("http://localhost:8000/api/import-customers", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ customers: results.data })
//           });
//           const data = await res.json();
//           alert(data.message);
//         } catch (error) {
//           console.error("CSV Import Error:", error);
//           alert("Failed to import customers.");
//         }
//       }
//     });
//   };

//   return (
//     <div className="p-4">
//       <h2 className="text-xl font-bold mb-4">Import Customers via CSV</h2>
//       <input type="file" accept=".csv" onChange={(e) => setFile(e.target.files[0])} />
//       <Button onClick={handleUpload} className="ml-4">Upload</Button>
//     </div>
//   );
// }

// function GenerateInvoice() {
//   const [customers, setCustomers] = useState([]);
//   const [selected, setSelected] = useState("");
//   const [items, setItems] = useState([{ description: "", quantity: 1, unit_price: 0 }]);
//   const [preview, setPreview] = useState(null);

//   useEffect(() => {
//     fetch("http://localhost:8000/api/customers")
//       .then(res => res.json())
//       .then(data => setCustomers(data.customers || []))
//       .catch(err => console.error("Error loading customers:", err));
//   }, []);

//   const handleItemChange = (i, field, value) => {
//     const newItems = [...items];
//     newItems[i][field] = field === "quantity" || field === "unit_price" ? parseFloat(value) : value;
//     setItems(newItems);
//   };

//   const addItem = () => setItems([...items, { description: "", quantity: 1, unit_price: 0 }]);

//   const previewInvoice = async () => {
//     const customer = customers.find(c => c.code === selected || c.name === selected);
//     if (!customer) return alert("Please select a customer");

//     try {
//       const res = await fetch("http://localhost:8000/api/calculate-tax", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ customer, items })
//       });

//       if (!res.ok) throw new Error(await res.text());

//       const taxData = await res.json();
//       setPreview({ customer, ...taxData });
//     } catch (err) {
//       console.error("Preview failed:", err);
//       alert("Preview error. See console.");
//     }
//   };

//   const submitInvoice = async () => {
//     if (!preview) return alert("Please preview invoice first");
//     try {
//       const pdfRes = await fetch("http://localhost:8000/api/generate-invoice-pdf", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(preview)
//       });

//       if (!pdfRes.ok) throw new Error(await pdfRes.text());

//       const blob = await pdfRes.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = "invoice.pdf";
//       a.click();
//     } catch (error) {
//       console.error("PDF generation failed:", error);
//       alert("Invoice generation failed");
//     }
//   };

//   return (
//     <div className="p-4">
//       <h2 className="text-xl font-bold mb-4">Generate Invoice</h2>
//       <div className="mb-4">
//         <label>Select Customer:</label>
//         <select onChange={(e) => setSelected(e.target.value)} className="border ml-2 p-2 rounded">
//           <option value="">-- Select --</option>
//           {customers.map(c => (
//             <option key={c.code || c.name} value={c.code || c.name}>{c.name} ({c.code})</option>
//           ))}
//         </select>
//       </div>

//       {items.map((item, i) => (
//         <div key={i} className="flex gap-2 mb-2">
//           <input placeholder="Description" className="border p-2 rounded" value={item.description} onChange={(e) => handleItemChange(i, "description", e.target.value)} />
//           <input type="number" placeholder="Qty" className="border p-2 rounded w-20" value={item.quantity} onChange={(e) => handleItemChange(i, "quantity", e.target.value)} />
//           <input type="number" placeholder="Unit Price" className="border p-2 rounded w-24" value={item.unit_price} onChange={(e) => handleItemChange(i, "unit_price", e.target.value)} />
//         </div>
//       ))}
//       <Button onClick={addItem} className="mt-2">Add Item</Button>
//       <br />
//       <div className="mt-4 flex gap-4">
//         <Button onClick={previewInvoice}>Preview Invoice</Button>
//         <Button onClick={submitInvoice} disabled={!preview}>Download PDF</Button>
//       </div>

//       {preview && (
//         <div className="mt-6 border p-4 bg-white text-black rounded">
//           <h3 className="font-bold text-lg mb-2">Invoice Preview</h3>
//           <p><strong>Customer:</strong> {preview.customer.code}</p>
//           <p><strong>Tax:</strong> ${preview.totalTax.toFixed(2)}</p>
//           <p><strong>Total:</strong> ${preview.totalAmount.toFixed(2)}</p>
//           <ul className="mt-2">
//             {preview.lines.map((line, idx) => (
//               <li key={idx}>
//                 {line.description} — Qty: {line.quantity}, Price: ${line.unit_price}, Tax: ${line.tax}
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </div>
//   );
// }

ConfigProvider.config({
  theme: {
    primaryColor: '#AD4679',
    colorPrimaryHover: '#AD4679',
  }
});

function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
